import React from 'react'
import RoomIcon from 'theorem-lib/src/assets/icons/room.svg'

type SpaceEmptyStateProps = {
  onAction: () => void
  hideAddSpaceButton?: boolean
}

export const SpaceEmptyState = (
  props: SpaceEmptyStateProps,
): React.ReactElement => (
  <div className='flex flex-col justify-center items-center w-full mt-20'>
    <div className='rounded-full border-primary-100 border-2 border-solid p-3 mb-4'>
      <RoomIcon />
    </div>
    <div className='text-primary-100 text-xl font-semibold mb-1'>
      You don&apos;t have any spaces yet
    </div>
    {props.hideAddSpaceButton
      ? (
        <>
          <div className='text-primary-300 text-base font-normal text-center max-w-[600px]'>
            As spaces are added by your team, you’ll see them here.
          </div>
        </>
      )
      : (
        <>
          <div className='text-primary-300 text-base font-normal text-center max-w-[600px]'>
            Adding pre-defined spaces and items will automatically create a high, medium, and low budget you can share
            with your client for faster decision making
          </div>
          <div className='text-primary-300 text-base font-normal text-center max-w-[500px]'>
            All spaces you have for this project will be displayed here
          </div>
        </>
      )}
  </div>
)
